export default __webpack_public_path__ + "media/color/hot-e55ca6c8.svg";